/**
 * Full-screen boot splash (public/index.html): visible until `clearLanguageSwitchSplash`
 * adds `html.ac-app-ready`. Language switch sets a session flag for analytics/debug only.
 */
export const LANG_SWITCH_SPLASH_KEY = "ac_lang_splash";

const APP_READY_CLASS = "ac-app-ready";

export function showLanguageSwitchSplashBeforeReload(lang: "en" | "ar") {
  localStorage.setItem("lang", lang);
  document.documentElement.setAttribute("dir", lang === "ar" ? "rtl" : "ltr");
  document.documentElement.setAttribute("lang", lang);
  document.documentElement.classList.remove(APP_READY_CLASS);
  try {
    sessionStorage.setItem(LANG_SWITCH_SPLASH_KEY, "1");
  } catch {
    /* ignore private mode */
  }
}

export function clearLanguageSwitchSplash() {
  try {
    sessionStorage.removeItem(LANG_SWITCH_SPLASH_KEY);
  } catch {
    /* ignore */
  }
  document.documentElement.classList.add(APP_READY_CLASS);
  const overlay = document.getElementById("ac-lang-switch-overlay");
  if (overlay) {
    overlay.setAttribute("aria-busy", "false");
    overlay.setAttribute("aria-hidden", "true");
  }
}
